/**
 * Country filter chips for English (international) place search. Shown only
 * when the place scope is 'all' so a traveller can narrow to one country.
 * Order: "All" first, then by Waylo relevance.
 */
export const COUNTRY_CHIPS: ReadonlyArray<{ code: string; label: string }> = [
  { code: 'all', label: 'All' },
  { code: 'RS', label: 'Serbia' },
  { code: 'HR', label: 'Croatia' },
  { code: 'BA', label: 'Bosnia' },
  { code: 'ME', label: 'Montenegro' },
  { code: 'MK', label: 'N. Macedonia' },
  { code: 'SI', label: 'Slovenia' },
  { code: 'HU', label: 'Hungary' },
  { code: 'RO', label: 'Romania' },
  { code: 'BG', label: 'Bulgaria' },
  { code: 'GR', label: 'Greece' },
];
